const permissions = {
  owner: 'Owner',
  admin: 'Contributor',
  viewer: 'Viewer',
};

export const getPermissionsValue = permission => {
  if (typeof permission === 'object') {
    return permission.permission;
  }

  return permission;
};

// An invite that hasn't been accepted yet. Matches `isPendingInvite` in functions/src/users/sharedWithUpdates.js.
export const isPendingInvite = permission => !!permission && typeof permission === 'object' && (permission.invited === 'true' || 'invite' in permission);

export const getPermissions = permission => permissions[getPermissionsValue(permission)];
